import * as React from 'react';
import { ToneDetailsPopupComponent } from '../tonedetailspopup/tonedetailspopupcomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ShareToneDto } from '../../../../core/dto/sharetone/sharetonedto';
import { ShareToneComponentProps, ShareToneComponentHandler, ShareToneComponentState } from './sharetonecomponent';
import { Strings } from '../../../../utils/resources/strings';
import { ShareToneCSSStyle } from './sharetonecss';
import { RoutingFeatures } from '../../navigation/routingfeature';

export class ShareToneViewImpl extends UIComponentViewImpl<ShareToneDto>
{

    bindHandlers()
    {   
        this.onFacebookClick = this.onFacebookClick.bind(this);
        this.onTwitterClick = this.onTwitterClick.bind(this);
        this.onFacebookHovered = this.onFacebookHovered.bind(this);
        this.onTwitterHovered = this.onTwitterHovered.bind(this);
        this.onFacebookHoveredExit = this.onFacebookHoveredExit.bind(this);
        this.onTwitterHoveredExit = this.onTwitterHoveredExit.bind(this);
    }

    draw(props: ShareToneComponentProps, state: ShareToneComponentState, cssStyle: ShareToneCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("------draw: " + state.isFacebookHovered);
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
               <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.context.getResources().getString(Strings.shareatone)} toneDto={props.toneDto} context={props.context}/>
                {/* <div style={cssStyle.getContentDivCSSStyle()}>
                       <img onClick={this.onFacebookClick} src={props.context.getResources().getImage("facebook.svg")} style={cssStyle.getContentImageCSSStyle()}/>
                        <label style={cssStyle.getImageTitleCSSStyle()}>
                                {props.context.getResources().getString(Strings.facebook)}
                        </label>
                </div> */}
                <div id="fb-root" style={cssStyle.getContentDivCSSStyle()}>
                   <div className="fb-share-button" data-href={"https://developers.facebook.com/docs/plugins/"} data-layout="button_count" data-size="large">
                   <a target="_blank" href={this.onFacebookClick()} >
                   <img onMouseLeave={this.onFacebookHoveredExit} onMouseEnter={this.onFacebookHovered} onClick={this.onFacebookClick} src={state.isFacebookHovered ? props.context.getResources().getImage("facebook_blue.svg") : props.context.getResources().getImage("facebook.svg")} style={cssStyle.getContentImageCSSStyle()}/>
                        <label style={cssStyle.getImageTitleCSSStyle()}>
                                {props.context.getResources().getString(Strings.facebook)}
                        </label>
                   {/* Share */}
                     </a>  
                   </div>
                </div>
                <div id="fb-root" style={cssStyle.getContentDivCSSStyle()}>
                   <div className="fb-share-button" data-href={"https://developers.facebook.com/docs/plugins/"} data-layout="button_count" data-size="large">
                   <a target="_blank" href={this.onTwitterClick()} >
                    <img onMouseLeave={this.onTwitterHoveredExit} onMouseEnter={this.onTwitterHovered} width="100%" height="100%" style={cssStyle.getContentImageCSSStyle()} src={state.isTwitterHovered ? props.context.getResources().getImage("twitter_blue.svg") : props.context.getResources().getImage("twitter.svg")}/>
                    <label style={cssStyle.getImageTitleCSSStyle()}>
                                {props.context.getResources().getString(Strings.twitter)}
                    </label>
                   {/* Share */}
                     </a>  
                   </div>
                </div>
                {/* <div style={cssStyle.getContentDivCSSStyle()}>
                       <img width="100%" height="100%" style={cssStyle.getContentImageCSSStyle()} src={props.context.getResources().getImage("twitter.svg")}/>
                       <a onClick={this.onTwitterClick} target="_blank" href={this.onTwitterClick()} />
                       <label style={cssStyle.getImageTitleCSSStyle()}>
                                {props.context.getResources().getString(Strings.twitter)}
                        </label>
                </div> */}
            </div>
        );
    }

    private onFacebookHovered()
    {
        (this.getUIComponentHandler() as ShareToneComponentHandler).onHovered(true, false);
    }

    private onFacebookHoveredExit()
    {
        (this.getUIComponentHandler() as ShareToneComponentHandler).onHoveredExit();
    }

    private onTwitterHovered()
    {
        (this.getUIComponentHandler() as ShareToneComponentHandler).onHovered(false, true);
    }

    private onTwitterHoveredExit()
    {
        (this.getUIComponentHandler() as ShareToneComponentHandler).onHoveredExit();
    }
    private onFacebookClick()
    {
        // (this.getUIComponentHandler() as ShareToneComponentHandler).shareOnFaceBook();
        if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
        {
            this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
            return;
        }
        else
        {
            let props = (this.getUIProps() as ShareToneComponentProps);
        let url = props.context.getProperty().getToneShareURL() + '?searchkey=' + props.toneDto.getId() + '&type=code';

        return props.context.getProperty().getFaceBookURL() +'?u='
        +encodeURIComponent(url) +'&p[app_id]=' + '&p[image]=' 
        + '&p[title]='+ props.toneDto.getToneName() + '&p[summary]=' + props.toneDto.getArtistName();
        }
    }

    private onTwitterClick()
    {
        if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
        {
            this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);

            return;
        }
        else
        {
        let props = (this.getUIProps() as ShareToneComponentProps);
        let url = props.context.getProperty().getToneShareURL() + '?searchkey=' + props.toneDto.getId() + '&type=code';
        return props.context.getProperty().getTwitterURL() +'?url='+encodeURIComponent(url) 
        +'&text='+ props.toneDto.getToneName();
        
        }
        // var site= "@Sixdee1";
        // var url = 'https://callertunes.etisalat.ae/PopulateSongs/AllTune?searchKey=313544&bannerTypeId=3&request_locale=en';
    //     let props = (this.getUIProps() as ShareToneComponentProps);
        //    return props.context.getProperty().getTwitterURL()+ '?url='
    //   +encodeURIComponent(props.toneDto.getToneUrl()) 
    //   +'&site='+encodeURIComponent(props.context.getProperty().getTwitterAPPID()) + 'image=' 
    //   + encodeURIComponent(props.toneDto.getImgPath()) 
    //   + 'text='+props.toneDto.getToneName();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/sharetone/sharetoneview.tsx